<p-table [columns]="redoReasonHeaders" [value]="_masterLists" selectionMode="single" [(selection)]="selecteRedoReason"
  (onRowSelect)="onRowSelect($event)">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let redoReasonField of columns">
        <ng-template [ngIf]="redoReasonField.showInGrid">
          <th id="{{redoReasonField.field+'Column'}}" [pSortableColumn]="redoReasonField.field == 'lab' ? redoReasonField.sort:redoReasonField.field">
            {{redoReasonField.header}}
            <p-sortIcon [field]="redoReasonField.field == 'lab' ? redoReasonField.sort:redoReasonField.field"></p-sortIcon>
          </th>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let redoReasonCol of columns">
        <ng-template [ngIf]="redoReasonCol.showInGrid">
          <td *ngIf="redoReasonCol.field != 'askForChannel' && redoReasonCol.field != 'lab' && redoReasonCol.field != 'active' && redoReasonCol.field != 'receptionIssue'" class="wrapword">
            {{rowData[redoReasonCol.field]}}
          </td>
          <td *ngIf="redoReasonCol.field == 'askForChannel'">
            <p-checkbox disabled [(ngModel)]="rowData[redoReasonCol.field]" binary="true"></p-checkbox>
          </td>
          <td *ngIf="redoReasonCol.field == 'active'">
            <p-checkbox disabled [(ngModel)]="rowData[redoReasonCol.field]" binary="true"></p-checkbox>
          </td>
          <td *ngIf="redoReasonCol.field=='lab'">
            {{rowData[redoReasonCol.field]!= null? rowData[redoReasonCol.field].name :''}}
          </td>
          <td *ngIf="redoReasonCol.field=='receptionIssue'">
            <p-checkbox disabled [(ngModel)]="rowData[redoReasonCol.field]" binary="true"></p-checkbox>
          </td>
        </ng-template>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div style="text-align:left">
      <button type="button" pButton icon="pi pi-plus" (click)="handleAddNewRedoReason()" label="Add" style="height: 35px;"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" [(visible)]="showRedoReasonDialog" [focusOnShow]="false"
  showEffect="fade" [modal]="true" [style.width]="'800px'" position="top" baseZIndex="10"
  (onHide)="this.showRedoReasonDialog = false;">
  <div *ngIf="redoReason">
    <div *ngFor="let redoReasonField of redoReasonHeaders">
      <div class="form-group m-2">
        <div>
          <label>{{redoReasonField.header}}</label>
        </div>
        <div *ngIf="redoReasonField.field == 'reasonName'">
          <input pInputText class="form-control" [ngClass]="{error:redoReason.reasonNameError}"
            [(ngModel)]="redoReason[redoReasonField.field]" [placeholder]="redoReasonField.header">
        </div>
        <div *ngIf="redoReasonField.field == 'reasonInfo'">
          <textarea pInputTextarea [rows]="6" [placeholder]="redoReasonField.header" name="reasonInfo" class="w-100"
            [(ngModel)]="redoReason[redoReasonField.field]" pInputTextarea autoResize="autoResize"></textarea>
        </div>
        <div *ngIf="redoReasonField.field == 'reasonCode'">
          <input pInputText class="form-control" [ngClass]="{error:redoReason.reasonCodeError}"
            [(ngModel)]="redoReason[redoReasonField.field]" [placeholder]="redoReasonField.header">
        </div>
        <div *ngIf="redoReasonField.field == 'lab'">
          <p-dropdown [options]="labOptions" [(ngModel)]="redoReason[redoReasonField.field]" [filter]="true"
            placeholder="Select a Lab" optionLabel="name" [showClear]="true"></p-dropdown>
        </div>
        <div *ngIf="redoReasonField.field == 'askForChannel'">
          <p-checkbox id="active" [(ngModel)]="redoReason[redoReasonField.field]" binary="true"></p-checkbox>
        </div>
        <div *ngIf="redoReasonField.field == 'defaultRedoStep'">
          <p-dropdown [options]="defaultRedoSteps" [(ngModel)]="redoReason[redoReasonField.field]" [filter]="true"
            placeholder="Select default Redo Step" optionLabel="name" [showClear]="true" [autoDisplayFirst]="true">
          </p-dropdown>
        </div>
        <div *ngIf="redoReasonField.field == 'active'">
          <p-checkbox id="active" [(ngModel)]="redoReason[redoReasonField.field]" binary="true"></p-checkbox>
        </div>
        <div *ngIf="redoReasonField.field == 'receptionIssue'">
          <p-checkbox id="receptionIssue" [(ngModel)]="redoReason[redoReasonField.field]" binary="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="false" (click)="handleSaveOrUpdate()" label="Save"
      style="float: right; height: 35px;"></button>
  </div>
</p-dialog>